import type { EventName } from "@lit/react";
import { SideNavItem as SideNavItemElement, type SideNavItemEventMap as _SideNavItemEventMap, } from "@vaadin/side-nav/vaadin-side-nav-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SideNavItemElement, };
export type SideNavItemEventMap = Readonly<{
    onExpandedChanged: EventName<_SideNavItemEventMap["expanded-changed"]>;
}>;
const events = { onExpandedChanged: "expanded-changed" } as SideNavItemEventMap;
export type SideNavItemProps = WebComponentProps<SideNavItemElement, SideNavItemEventMap>;
export const SideNavItem = createComponent({
    elementClass: SideNavItemElement, events, react: React, tagName: "vaadin-side-nav-item"
});
